<template>
  <div class="app-main-content">
    <div class="grid-view" style="height: calc(100vh - 130px)">
      <div class="main-content">
        <div class="operations">
          <el-form :inline="true" label-position="left" @submit.native.prevent>
            <el-form-item :label="$t('common.btn.query')">
              <el-input
                v-model="searchConditions.likeName"
                style="width: 286px;"
                :placeholder="$t('common.tips.fuzzySearch')"
                @keyup.enter.native="fetchPagingCountryList"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="fetchPagingCountryList">{{ $t('common.btn.query') }}</el-button>
              <el-button v-if="hasPermission" type="primary" @click="popCountryAddFormDialog">{{ $t('common.btn.new') }}</el-button>
              <el-button v-if="hasPermission" type="primary" @click="popCountryEditFormDialog">{{ $t('common.btn.edit') }}</el-button>
              <el-button v-if="hasPermission" type="danger" @click="toBatchDel">{{ $t('common.btn.delete') }}</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            :show-side-bar="false"
            :column-defs="columnDefs"
            :row-data="rowData"
            :grid-options="gridOptions"
            :side-bar="sideBarDefs"
            style="width: 100%;"
            @gridReady="onReady"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            v-show="searchConditions.total>0"
            :total="searchConditions.total"
            :page.sync="searchConditions.pageNum"
            :limit.sync="searchConditions.pageSize"
            @pagination="fetchPagingCountryList"
          />
        </div>
      </div>
    </div>
    <!-- 国家维护 -->
    <el-dialog
      slot="reference"
      class="dialog"
      :visible.sync="isShowCountryMaintain"
      :title="$t('baseInfo.country.countryMaintain')"
      inline-message
      width="50%"
    >
      <el-form ref="countryForm" :model="countryForm" label-width="120px" label-position="right">
        <el-form-item :label="$t('baseInfo.country.serialNumber')" prop="serialNumber">
          <el-input-number
            v-model="countryForm.serialNumber"
            :min="1"
            :max="999999"
            size="mini"
            style="width: calc(50% - 50px);"
            controls-position="right"
          />
        </el-form-item>
        <el-form-item prop="code">
          <span slot="label" class="blue">{{ $t('baseInfo.country.code') }}</span>
          <el-input ref="txtCode" v-model="countryForm.code" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.country.chineseName')" prop="chineseName">
          <el-input v-model="countryForm.chineseName" size="mini" />
        </el-form-item>
        <el-form-item prop="name">
          <span slot="label" class="blue">{{ $t('baseInfo.country.englishName') }}</span>
          <el-input ref="txtName" v-model="countryForm.name" size="mini" />
        </el-form-item>
        <el-form-item prop="interchangeCode">
          <span slot="label" class="blue">{{ $t('baseInfo.country.interchangeCode') }}</span>
          <el-input v-model="countryForm.interchangeCode" size="mini" />
        </el-form-item>
        <el-form-item prop="isoCode">
          <span slot="label" class="blue">{{ $t('baseInfo.country.isoCode') }}</span>
          <el-input v-model="countryForm.isoCode" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.country.continent')" prop="continent">
          <el-select v-model="countryForm.continent" clearable>
            <el-option
              v-for="(item, index) in continentList"
              :key="index"
              :value="item.name"
              :label="item.name"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="medium " type="primary" @click="submitCountry">{{ $t('common.btn.save') }}</el-button>
        <el-button size="medium " @click="cancelSaveOrEdit">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'
import { batchDelCountry, getCountryByCode, getPagingCountryList, saveCountry } from '@/api/country'
import { getLoading } from '@/utils/utilBaseElement'
import { exportExcel } from '@/utils/tableDataExportUtils'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'Country',
  data() {
    return {
      searchConditions: {
        likeName: '',
        pageNum: 1,
        pageSize: 10,
        total: 4
      },
      columnDefs: [
        {
          headerName: '', checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('baseInfo.country.serialNumber'),
          field: 'serialNumber'
        }, {
          headerName: this.$t('baseInfo.country.code'),
          field: 'code'
        }, {
          headerName: this.$t('baseInfo.country.englishName'),
          field: 'name'
        }, {
          headerName: this.$t('baseInfo.country.chineseName'),
          field: 'chineseName'
        }, {
          headerName: this.$t('baseInfo.country.continent'),
          field: 'continent'
        }, {
          headerName: this.$t('baseInfo.country.interchangeCode'),
          field: 'interchangeCode'
        }, {
          headerName: this.$t('baseInfo.country.isoCode'),
          field: 'isoCode'
        }],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      gridOptions: {
        rowClassRules: {
          'grid-row-zebra-even': function(params) {
            return !(params.rowIndex % 2)
          },
          'grid-row-zebra-odd': function(params) {
            return (params.rowIndex % 2)
          }
        },
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        paginationNumberFormatter: function(params) {
          return '[' + params.value.toLocaleString() + ']'
        },
        suppressContextMenu: false,
        getContextMenuItems: () => {
          const self = this
          return [
            {
              name: self.$t('CargoMsg.Cargo_ExcelExport'),
              action: function() {
                self.exportExcelHandler()
              }
            }
          ]
        }
      },
      isShowCountryMaintain: false,
      countryForm: {
        serialNumber: 1,
        code: '',
        chineseName: '',
        name: '',
        interchangeCode: '',
        isoCode: ''
      },
      continentList: []
    }
  },
  computed: {
    hasPermission() {
      // 只有P1用户有权限编辑，新增、删除
      return this.$store.getters.isP1
    }
  },
  mounted() {
    this.fetchPagingCountryList()
  },
  methods: {
    onReady(params) {
      const self = this
      // params.api.sizeColumnsToFit()
      self.gridOptions.columnApi = params.api
      window.addEventListener('resize', function() {
        setTimeout(function() {
          // params.api.sizeColumnsToFit()
          self.onFirstDataRendered(self.gridOptions)
        })
      })
    },
    onFirstDataRendered(gridOptions) {
      const allColumnIds = []
      gridOptions.columnApi.getAllColumns().forEach(function(column) {
        allColumnIds.push(column.colId)
      })
      setTimeout(function() {
        gridOptions.columnApi.autoSizeColumns(allColumnIds)
      })
    },
    fetchPagingCountryList() {
      const self = this
      const params = { ...this.searchConditions }
      const loading = getLoading()
      getPagingCountryList(params).then(res => {
        if (res.ok) {
          self.rowData = res.data.list
          self.searchConditions.pageNum = res.data.pageNum
          self.searchConditions.pageSize = res.data.pageSize
          self.searchConditions.total = Number(res.data.total)
        } else {
          return Promise.reject(res.message)
        }
      }).finally(() => loading.close())
    },
    popCountryAddFormDialog() {
      this.continentList = getCacheListByKey(basicCacheKeys.basic_data_Continent)
      this.countryForm = {}
      this.countryForm.isEdit = false
      this.isShowCountryMaintain = true
    },
    popCountryEditFormDialog() {
      this.continentList = getCacheListByKey(basicCacheKeys.basic_data_Continent)
      const self = this
      getGridSelectedIds(this.gridOptions).then(ids => {
        if (ids.length !== 1) {
          this.$message.error(this.$t('common.tips.hasOneAtleast'))
        } else {
          self.countryForm = { ...getGridSelected(this.gridOptions)[0] }
          this.countryForm.isEdit = true
          self.isShowCountryMaintain = true
        }
      })
    },
    toBatchDel() {
      const self = this
      const countryArray = this.getCountrySelected()
      if (countryArray) {
        this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.confirm'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          batchDelCountry(countryArray).then(res => {
            if (res.ok) {
              self.fetchPagingCountryList()
              this.$message({
                type: 'success',
                message: this.$t('common.tips.deleteSuccess')
              })
            } else {
              this.$message({
                type: 'info',
                message: this.$t('common.tips.deleteSuccess')
              })
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.tips.cancelDelete')
          })
        })
      }
    },
    getCountrySelected() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (selectedRows.length <= 0) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return null
      }
      return selectedRows
    },
    async submitCountry() {
      if (!await this.checkCountry()) {
        return
      }
      if (!this.countryForm.isEdit) {
        this.toAddCountry()
      } else {
        this.editCountry()
      }
    },
    // 编辑海关商品编码
    editCountry() {
      saveCountry(this.countryForm, this.countryForm.uuid).then(res => {
        if (res.ok) {
          this.isShowCountryMaintain = false
          this.$message({ message: this.$t('common.tips.editSuccess'), type: 'success' })
        }
      }).then(() => {
        this.fetchPagingCountryList()
      })
    },
    // 新增海关商品编码
    toAddCountry() {
      saveCountry(this.countryForm).then(res => {
        if (res.ok) {
          this.isShowCountryMaintain = false
          this.$message({ message: this.$t('common.tips.saveSuccess'), type: 'success' })
        }
      }).then(() => {
        this.fetchPagingCountryList()
      })
    },
    // 取消保存或者编辑
    cancelSaveOrEdit() {
      this.isShowCountryMaintain = false
      this.countryForm = {}
    },
    async checkCountry() {
      if (!this.countryForm.code) {
        this.$message.warning(this.$t('Information.CodeCannotBeEmpty'))
        this.$refs.txtCode.focus()
        return false
      }
      const existed = await getCountryByCode(this.countryForm.code).then(resp => resp.data)
      if (existed && existed.uuid !== this.countryForm.uuid) {
        this.$message.warning(this.$t('Information.CodeDuplicatedPleaseReEnter'))
        this.$refs.txtCode.focus()
        return false
      }
      if (!this.countryForm.name) {
        this.$message.warning(this.$t('CargoMsg.Cargo_EnglishNameCanTBeEmpty'))
        this.$refs.txtName.focus()
        return false
      }
      if (!this.countryForm.interchangeCode) {
        this.$message.warning(this.$t('baseInfo.basicData.blMode.interchangeCodeCheck'))
        this.$refs.txtName.focus()
        return false
      }
      if (!this.countryForm.isoCode) {
        this.$message.warning(this.$t('baseInfo.basicData.blMode.isoCodeCheck'))
        this.$refs.txtName.focus()
        return false
      }
      return true
    },
    exportExcelHandler() {
      const columnDefs = []
      this.columnDefs.forEach(column => columnDefs.push({ colDef: column }))
      exportExcel(this.$t('Information.Country'), this.rowData, columnDefs)
    }
  }
}
</script>

<style scoped>

</style>
